// src/hooks/CanopyWebSocket.js
import { useState, useCallback, useRef, useEffect } from 'react';
import SockJsClient from 'react-stomp';

export const useWebSocket = (url, topic) => {
  const [connected, setConnected] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);
  const clientRef = useRef(null);
  const [shouldConnect, setShouldConnect] = useState(false);
  
  // Delay connection to ensure proper initialization
  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldConnect(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  
  const handleConnect = useCallback(() => {
    console.log('WebSocket connected to:', url);
    setConnected(true);
  }, [url]);

  const handleDisconnect = useCallback(() => {
    console.log('WebSocket disconnected');
    setConnected(false);
  }, []);

  const handleMessage = useCallback((message) => {
    console.log('WebSocket message received:', message);
    setLastMessage(message);
  }, []);

  return {
    connected,
    lastMessage,
    renderWebSocketClient: () => shouldConnect ? (
      <SockJsClient
        url={url}
        topics={[topic]}
        onConnect={handleConnect}
        onDisconnect={handleDisconnect}
        onMessage={handleMessage}
        ref={clientRef}
        debug={true}
      />
    ) : null
  };
};